<template>
    <div>
        <Head>
            <title>{{ pageTitle }}</title>
            <meta
                content="Anonymous VC Reviews, OpenScout Marketplace, Anonymous Founder Marketplace, Investor Lists, and much more."
                name="description">
            <meta :content="pageTitle" name="twitter:title">
            <meta :content="pageTitle" property="twitter:title">
            <meta :content="pageTitle" property="og:title">
            <meta content="website" property="og:type">
            <meta
                content="Anonymous VC Reviews, OpenScout Marketplace, Anonymous Founder Marketplace, Investor Lists, and much more."
                property="og:description">
            <meta content="/img/open-graph.jpg" property="og:image">
            <meta
                content="Anonymous VC Reviews, OpenScout Marketplace, Anonymous Founder Marketplace, Investor Lists, and much more."
                name="twitter:description">
            <meta content="/img/open-graph.jpg" name="twitter:image">
            <meta content="summary_large_image" name="twitter:card">
        </Head>

        <SidebarMobile
            :account-navigation="accountNavigationComputed" :navigation="navigation"
            :secondary-navigation="secondaryNavigation" :sidebar-open="sidebarOpen"
            @toggle-sidebar="toggleSidebar"/>
        <SidebarDesktop
            :account-navigation="accountNavigationComputed" :navigation="navigation"
            :secondary-navigation="secondaryNavigation"/>

        <slot :toggle-sidebar="toggleSidebar"/>
    </div>
</template>

<script>
import SidebarDesktop from '@/Layouts/Legacy/Partials/SidebarDesktop.vue';
import SidebarMobile from '@/Layouts/Legacy/Partials/SidebarMobile.vue';
import {computed} from 'vue';
import {Head, usePage} from '@inertiajs/vue3';

export default {
    components: {
        Head,
        SidebarMobile,
        SidebarDesktop,
    },
    props: {
        title: {
            type: String,
            required: false,
        }
    },
    setup() {
        const navigation = computed(() => usePage().props.navigation);
        const user = computed(() => usePage().props.user);

        return {user, navigation};
    },
    data() {
        return {
            sidebarOpen: false,
            secondaryNavigation: [
                {name: 'Chat With Us', href: "javascript:Intercom('show');"},
                {name: 'Knowledge Base', href: 'https://help.landscape.vc/'},
                {
                    name: 'About Us',
                    href: '#',
                    current: false
                },

            ],
            accountNavigation: [
                {name: 'Settings', href: this.route('settings.user'), method: 'GET'},
                {
                    name: 'CRM Setup',
                    href: this.route('signals.crm.index'),
                    method: 'GET',
                    hidden: !this.user?.signals_enabled
                },
                {name: 'API Tokens', href: this.route('api-tokens.index'), method: 'GET'},
                {name: 'Logout', href: this.route('logout'), method: 'POST'},
            ]
        };
    },

    computed: {
        accountNavigationComputed() {
            if (!this.user) {
                return [];
            }

            return this.accountNavigation;
        },
        pageTitle() {
            if (this.title) {
                return this.title + ' - Landscape';
            }

            return 'Landscape - Making Fundraising better for everyone';
        }
    },

    methods: {
        toggleSidebar(value) {
            this.sidebarOpen = value;
        }
    }

};
</script>
